import type {EventSocketMessage} from '@myparcel-frontend/event-service';
import type {ComposerTranslation} from 'vue-i18n';
import {EventCaseName} from '@myparcel-frontend/event-service';
import {useNotification} from '@myparcel-frontend/notifications';
import {matchPrintingEvent} from '@myparcel-frontend/printing-service';
import {useDirectPrintingStore} from '../../store/directPrinting/directPrintingStore';

export default function usePrintingServiceEvents() {
  const {addNotification} = useNotification();

  const {hasPendingPrintJobs, removePendingPrintJob} = useDirectPrintingStore();

  const sendNotification = (messageCase: string, t: ComposerTranslation): void => {
    if (messageCase === EventCaseName.Printed) {
      addNotification({
        variant: 'success',
        body: t('printing.directPrinting.notifications.printJob.success'),
      });

      return;
    }

    addNotification({
      variant: 'alert',
      body: t('printing.directPrinting.notifications.printJob.error'),
    });
  };

  const updateStoreAndShowNotification = (message: EventSocketMessage, t: ComposerTranslation): void => {
    if (!hasPendingPrintJobs(message.aggregate.id) || !message.message?.case) {
      return;
    }

    sendNotification(message.message.case, t);

    removePendingPrintJob(message.aggregate.id);
  };

  const handlePrintingMessage = (message: EventSocketMessage, t: ComposerTranslation) =>
    matchPrintingEvent(message, {
      onPrinted: () => updateStoreAndShowNotification(message, t),
      onPrintErrored: () => updateStoreAndShowNotification(message, t),
    });

  return {
    handlePrintingMessage,
  };
}
